module.exports = __webpack_public_path__ + "img/feature02.f08387a.jpg";